// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f376fba5","977":"8a213aac"}[chunkId] + ".chunk.js";
};